import React from 'react';
import { CheckCircle, XCircle } from 'lucide-react';

export const getPasswordStrength = (password) => {
  const strength = {
    length: password.length >= 8,
    uppercase: /[A-Z]/.test(password),
    lowercase: /[a-z]/.test(password),
    number: /\d/.test(password)
  };

  return {
    ...strength,
    score: Object.values(strength).filter(Boolean).length * 25
  };
};

const STRENGTH_LEVELS = [
  { min: 100, label: 'Forte', bar: 'bg-green-500', text: 'text-green-600' },
  { min: 75, label: 'Boa', bar: 'bg-yellow-500', text: 'text-yellow-600' },
  { min: 50, label: 'Razoável', bar: 'bg-orange-500', text: 'text-orange-600' },
  { min: 0, label: 'Fraca', bar: 'bg-red-500', text: 'text-red-600' }
];

const CHECKS = [
  { key: 'length', label: '8+ caracteres' },
  { key: 'uppercase', label: 'Letra maiúscula' },
  { key: 'lowercase', label: 'Letra minúscula' },
  { key: 'number', label: 'Número' }
];

/**
 * Live strength meter and the full list of password rules. The last list covers
 * what the server also rejects but the browser can't check as the user types.
 */
const PasswordRequirements = ({ password }) => {
  const strength = getPasswordStrength(password);
  const level = STRENGTH_LEVELS.find(({ min }) => strength.score >= min);

  return (
    <div className="mt-3">
      <div className="flex items-center justify-between mb-1">
        <span className="text-xs text-gray-600">Força da Senha:</span>
        <span className={`text-xs font-semibold ${level.text}`}>{level.label}</span>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
        <div
          className={`h-full transition-all duration-300 ${level.bar}`}
          style={{ width: `${strength.score}%` }}
        />
      </div>

      <div className="mt-3 space-y-2">
        <p className="text-xs font-medium text-gray-700">Requisitos:</p>
        <div className="grid grid-cols-2 gap-2">
          {CHECKS.map(({ key, label }) => (
            <div key={key} className="flex items-center text-xs">
              {strength[key] ? (
                <CheckCircle className="h-4 w-4 text-green-500 mr-1" />
              ) : (
                <XCircle className="h-4 w-4 text-gray-300 mr-1" />
              )}
              <span className={strength[key] ? 'text-green-700' : 'text-gray-500'}>{label}</span>
            </div>
          ))}
        </div>
        <p className="text-xs font-medium text-gray-700">A senha também não pode:</p>
        <ul className="text-xs text-gray-500 list-disc list-inside space-y-1">
          <li>conter seu nome ou a parte do seu email antes do @</li>
          <li>ser uma senha comum, como "password123"</li>
          <li>repetir uma das suas últimas 5 senhas</li>
        </ul>
      </div>
    </div>
  );
};

export default PasswordRequirements;
